(function() {
	'use strict';

	var $infoBox = $('.js-question');


	// FAQ toggler
	if ( $infoBox.length > 0 ) {
		$infoBox.on('click', function() {
			var $self = $(this),
				$target = $self,
				targetOpened = !!$target.hasClass('expand');

			// Close all boxes
			$infoBox.removeClass('expand');

			// Check current box for toggle
			if (targetOpened) {
				$target.removeClass('expand');
			} else {
				$target.addClass('expand');
			}
		});
	}

	//Modal video
	var modals = document.querySelectorAll('.modal.yt-video');

	modals.forEach(function(modal) {
		var $modal = $(modal);
		var $modalContent = $modal.find('.modal-body');
		var $videoElement = $modalContent.find('video');

		// Use jQuery's `.on()` for Bootstrap modal events (Bootstrap 4 and older)
		$modal.on('shown.bs.modal', function() {
			var $iframe = $modalContent.find('iframe');
			if ($iframe.length !== 0) {
				$iframe[0].contentWindow.postMessage(
					'{ "event":"command", "func":"playVideo", "args":"" }', '*'
				);
			}
		});

		$modal.on('hide.bs.modal', function() {
			var $iframe = $modalContent.find('iframe');
			if ($iframe.length !== 0) {
				$iframe[0].contentWindow.postMessage(
					'{ "event":"command", "func":"pauseVideo", "args":"" }', '*'
				);
			} else if ($videoElement.length) {
				$videoElement[0].load();
			}
		});
	});

	// Add click event listener to `.play-icon-wrap` to trigger autoplay
	var playIcons = document.querySelectorAll('.play-icon-wrap');
	playIcons.forEach(function(playIcon) {
		playIcon.addEventListener('click', function() {
			// Locate the modal video iframe
			const video = document.querySelector('.modal-video');

			if (video) {
				// Append autoplay=1 to the video src only if it's not already added
				var videoSrc = video.getAttribute('src');
				if (!videoSrc.includes('autoplay=1')) {
					video.setAttribute('src', videoSrc + '&autoplay=1');
				}
			}
		});
	});
})();

var sliderInfNotiSecMed = tns({
	"container": ".slider-sliderSliNotiSecSm",
	"controlsContainer": ".slider-sliderSliNotiSecSm-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"center": false,
	"slideBy": 1,
	"fixedWidth": 270,
	"gutter": 16,
	"loop": false,
	"responsive": {
		"768": {
			"slideBy": 1,
			"controls": false,
			"fixedWidth": 290,
			"gutter": 32
		},
		"1280": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		},
		"1600": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		}
	}
});

var sliderInfNotiSecMedRating = tns({
	"container": ".slider-sliderSliNotiSecSmRating",
	"controlsContainer": ".slider-sliderSliNotiSecSmRating-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"center": false,
	"slideBy": 1,
	"fixedWidth": 270,
	"gutter": 16,
	"loop": false,
	"responsive": {
		"768": {
			"slideBy": 1,
			"controls": false,
			"fixedWidth": 290,
			"gutter": 32
		},
		"1280": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		},
		"1600": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		}
	}
});

